// Imports
import * as jQuery from 'jquery';
(<any>window).$ = (<any>window).jQuery = jQuery;

import { initCookieConsent } from './cookie-consent';

import Swiper, {
    Navigation,
    Pagination,
    Autoplay,
    FreeMode,
    EffectFade,
} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, FreeMode, EffectFade]);

import mixitup from 'mixitup';

// import * as liteYoutube from 'lite-youtube-embed';

// Variables
const navToggle = document.querySelector('.nav-toggle');
const cookieAccept = document.querySelector('#acceptCookies');
var navbar = document.getElementById('site-header');
var mainNav = document.getElementById('main-navigation');

$(document).ready(() => {
    initCookieConsent();

    window.onscroll = function () {
        hideTopBanner();
    };

    // Get the offset position of the navbar
    var sticky = navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function hideTopBanner() {
        if (window.pageYOffset >= sticky + 40) {
            navbar.classList.add('sticky');
            mainNav.classList.add('top-height');
        } else {
            navbar.classList.remove('sticky');
            mainNav.classList.remove('top-height');
        }
    }

    // Used for body scroll-lock when menu or contact module is open
    var phoneWidthMenu = window.matchMedia('(max-width: 719px)');

    // Toggler for mobile nav
    navToggle.addEventListener('click', () => {
        navToggle.classList.toggle('nav-toggle--active');

        // Prevent scroll on document if on mobile
        if (phoneWidthMenu.matches) {
            $('html').toggleClass('scroll-lock');
        }
    });

    // Cookie toggle
    if (cookieAccept != null) {
        cookieAccept.addEventListener('click', () => {
            $('.cookie-information').toggleClass('accepted');
        });
    }

    // Toggler for dropdown on mobile
    $('.dropdown-toggle').on('click', function (event) {
        $(this).closest('.dropdown').toggleClass('dropdown--active');
        $(this).find('.icon').toggleClass('icon--active');
        $(this)
            .siblings('.dropdown-content')
            .toggleClass('dropdown-content--active');
    });

    // For swiper.js
    const articleHeading = document.querySelectorAll('.article-heading');
    const swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        speed: 600,

        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },

        autoplay: {
            delay: 4000,
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="dot swiper-pagination-bullet">${articleHeading[index].textContent}</span>`;
            },
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Retrieve first category to be used as default load in function below
    const firstFilter = $(
        '.selector-container .category-selector:first-child'
    ).data('filter');
    if (firstFilter != null) {
        // Filter function using Mixitup.js for Partnerblock
        var mixer = mixitup('.mix-container', {
            selectors: {
                target: '.mix',
            },
            load: {
                filter: firstFilter,
            },
            animation: {
                enable: false,
            },
        });
    }
});

// Statistics in StatisticsBlock.cshml
var maleStatisticsAreVisible = true;
const maleButton = document.getElementById("startpage-statistic-male");
const femaleButton = document.getElementById("startpage-statistic-female");
const maleStatistics = Array.from(document.getElementsByClassName('statistics-male') as HTMLCollectionOf<HTMLElement>);
const femaleStatistics = Array.from(document.getElementsByClassName('statistics-female') as HTMLCollectionOf<HTMLElement>);

if (maleButton != null && femaleButton != null) {

    maleButton.style.background = '#efefef';
    femaleButton.style.background = '#ffffff';
    // Switching from female-statistics to male-statistics
    maleButton.addEventListener('click', event => {
        if (maleStatisticsAreVisible == false) {
            femaleStatistics.forEach(statistic => {
                statistic.style.display = 'none';
            });

            maleStatistics.forEach(statistic => {
                statistic.style.display = 'block';
            });
            femaleButton.style.backgroundColor = '#ffffff';
            maleButton.style.backgroundColor = '#efefef';
            maleStatisticsAreVisible = true;
        }

    })

    // Switching from male-statistics to female-statistics
    femaleButton.addEventListener('click', event => {
        if (maleStatisticsAreVisible == true) {
            maleStatistics.forEach(statistic => {
                statistic.style.display = 'none';
            });

            femaleStatistics.forEach(statistic => {
                statistic.style.display = 'block';
            });
            maleStatisticsAreVisible = false;
            femaleButton.style.backgroundColor = '#efefef';
            maleButton.style.backgroundColor = '#ffffff';

        }

    })
}



